export default "__VITE_ASSET__DUh8iOwa__"